import { render, staticRenderFns } from "./ReleaseDDEXUpload2.vue?vue&type=template&id=56156d60&"
import script from "./ReleaseDDEXUpload2.vue?vue&type=script&lang=js&"
export * from "./ReleaseDDEXUpload2.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseDDEXUpload2.vue?vue&type=style&index=0&id=56156d60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports